export default __webpack_public_path__ + "2a07716ab6abf2758fb9c2000b1f482c.png";